<style lang="stylus">
    .iconfont
        width 100%
        height 100%
        .iconfont-topbar
            display flex
            justify-content space-between
            align-items center
            height 40px
            width 100%
            padding 0 22px 0 16px
            border-bottom 1px solid var(--border-color-gray1)
            .header-prefix
                display flex
                align-items center
                >p
                    font-size 14px
                    font-weight 700
                    color var(--text-color-primary)
                    margin-right 4px
                >img
                    width 24px
                    height 24px
                    margin-right 4px
                .ivu-tooltip
                    margin-bottom auto
                    .ivu-tooltip-rel
                        display block
                        width 8px
                        height 8px
                        svg
                            width 8px
                            height 8px
                            color: var(--svg-color-black);
                            display block;
                    .ivu-tooltip-arrow
                        border-bottom-color var(--border-color-tips) !important
                    .ivu-tooltip-inner
                        background-color var(--bg-color-tips) !important
                        border-radius 8px
                        p
                            line-height 20px
                            color #fff
                            font-size 12px
                            text-align left !important
        .iconfont-searchblock
            padding 16px
        .iconfont-tool
            width 100%
            padding 0 16px
            display flex
            column-gap 8px
            margin-bottom 16px
            .tool-dropdown
                min-width 68px
                cursor pointer
            .tool-color
                position relative
                display flex
                justify-content center
                align-items center
                width 28px
                height 28px
                border 1px solid var(--border-color-gray1)
                border-radius 4px
                cursor pointer
                flex-shrink 0
                .tool-colorbtn
                    display flex
                    justify-content center
                    align-items center
                    width 100%
                    height 100%
                img
                    width 16px
                    height 16px

                .iconfont-color
                    position fixed
                    left 170px
                    top 138px
                    z-index 2
            .tool-reset
                position relative
                display flex
                justify-content center
                align-items center
                width 28px
                height 28px
                border 1px solid var(--border-color-gray1)
                border-radius 4px
                cursor pointer
                flex-shrink 0
                svg
                    width 16px
                    height 16px
                    color: var(--svg-color-primary);
        .iconfont-scrollbox
            height calc(100% - 148px)
            .iconfont-scrollview
                width 100%
                padding-left 16px
                display flex
                flex-wrap wrap
                column-gap 8px
                row-gap 8px
                // overflow auto
                .iconfont-iconblock
                    display flex
                    justify-content center
                    align-items center
                    width 48px
                    height 48px
                    background var(--bg-color-left-panel-icon-font-item)
                    border-radius 6px
                    cursor pointer
                    >div
                        width 32px
                        height 32px
                        svg
                            width 100% !important
                            height 100% !important
                    &:hover
                        background var(--bg-color-left-panel-icon-font-item-hover)
                &.force-color
                    svg
                        fill currentColor
                        stroke currentColor
                        *
                            fill currentColor
                            stroke currentColor
                .iconfont-empty
                    display flex
                    justify-content center
                    align-items center
                    width 100%
                    height 100%
                    p
                        margin-top -200px
                        font-size 14px
                        color var(--text-color-primary)
                .iconfont-loading
                    width 100%
                    display flex
                    justify-content center
                    svg
                        color var(--themeColor)
</style>

<template>
    <div class="iconfont">
        <div class="iconfont-topbar">
            <a class="header-prefix" href="https://www.iconfont.cn/" target="_blank">
                <img src="@/app/assets/leftPanel/iconfont/iconfont.svg" alt="" />
                <p>Iconfont</p>
                <Tooltip @click.native.prevent class="tips-mark" :max-width="200" placement="bottom">
                    <iconSymbol name="copyright" />
                    <div slot="content">
                        <p>{{ $t("tips") }}</p>
                    </div>
                </Tooltip>
            </a>
        </div>

        <div class="iconfont-searchblock">
            <Search v-model="searchStr" @toSearch="toSearch" :placeholderStr="$t('placeholder')" />
        </div>

        <div class="iconfont-tool">
            <div class="tool-dropdown">
                <Dropdown v-model="colorModeIndex" :dataList="colorModeList" @selectData="setColorMode"></Dropdown>
            </div>
            <div class="tool-dropdown">
                <Dropdown v-model="pxIndex" :dataList="dataList" @selectData="setPx"></Dropdown>
            </div>
            <div class="tool-color">
                <div class="tool-colorbtn" @click.stop="toggleColorModal">
                    <img src="@/app/assets/leftPanel/public/color.png" alt="" />
                </div>
                <div class="iconfont-color">
                    <Palette
                        v-if="showColor"
                        from="plugin"
                        :pluginColor="pluginColor"
                        :force="true"
                        :useMask="false"
                        :windowType="'iconfont'"
                        @setColor="setColor"
                        @click.native.stop
                        @mousedown.native.stop
                    />
                </div>
            </div>
            <div class="tool-reset" @click.stop="reset">
                <iconSymbol name="leftpanel-refresh-icon" />
            </div>
        </div>

        <ScrollView class="iconfont-scrollbox">
            <div class="iconfont-scrollview" :class="{ 'force-color': pluginColor != '' }" :style="{ color: pluginColor }">
                <div
                    class="iconfont-iconblock"
                    v-for="item in iconList"
                    :key="item.id"
                    @mousedown="doMousedown(item.show_svg)"
                    :content="$t(item.name)"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <div v-html="item.show_svg"></div>
                </div>
                <div v-if="!loading && isEmpty" class="iconfont-empty">
                    <p>{{ $t("nodata") }}</p>
                </div>
                <div v-show="loading" class="iconfont-loading">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="24"
                        height="24px"
                        viewBox="0 0 50 50"
                        style="enable-background: new 0 0 50 50"
                        xml:space="preserve"
                    >
                        <path
                            fill="currentColor"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                        >
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="rotate"
                                from="0 25 25"
                                to="360 25 25"
                                dur="0.8s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </svg>
                </div>
                <div v-show="!loading && !end" ref="scrollEl" style="width: 100%; height: 10px"></div>
            </div>
        </ScrollView>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Search from "./public/_Search.vue";
    import Dropdown from "./public/_Dropdown.vue";
    import Palette from "@/app/components/Common/Color/Palette.vue";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    @Component({
        components: {
            Search,
            Dropdown,
            Palette,
            ScrollView,
        },
    })
    export default class Iconfont extends Vue {
        searchStr = "";
        toSearch() {
            if (this.searchStr == "" && this.pageInfo.q == "iconfont") {
                // 当前未处于搜索状态，无需刷新内容
                return;
            }
            if (this.searchStr == "") {
                this.pageInfo.q = "iconfont";
            } else {
                this.pageInfo.q = this.searchStr;
            }
            this.pageInfo.page = 1;
            this.getData();
        }

        pxIndex = 3;
        dataList = [
            {
                label: "16px",
                value: 16,
            },
            {
                label: "24px",
                value: 24,
            },
            {
                label: "32px",
                value: 32,
            },
            {
                label: "48px",
                value: 48,
            },
            {
                label: "64px",
                value: 64,
            },
            {
                label: "128px",
                value: 128,
            },
        ];
        setPx(data: number) {}
        colorModeIndex = 0;
        get colorModeList() {
            return [
                {
                    label: this.$t("allColor"),
                    value: "",
                },
                {
                    label: this.$t("singleColor"),
                    value: "0",
                },
                {
                    label: this.$t("manyColor"),
                    value: "1",
                },
            ];
        }
        setColorMode(data: number) {
            this.pageInfo.fills = this.colorModeList[this.colorModeIndex].value;
            this.pageInfo.page = 1;
            this.getData();
        }

        showColor = false;
        pluginColor = "";
        toggleColorModal() {
            this.showColor = !this.showColor;
            if (this.showColor) {
                document.onclick = () => {
                    this.showColor = false;
                    document.onclick = null;
                };
            }
        }
        setColor(color) {
            this.showColor = false;
            this.pluginColor = color;
        }

        pageInfo = {
            // 默认参数
            fills: "",
            page: 1,
            pageSize: 80,
            q: "iconfont",
        };
        iconList = [];
        loading = false;
        get isEmpty() {
            return this.iconList.length == 0;
        }
        end = false;
        getData() {
            if (this.loading) return;
            this.cancelObserve();
            this.loading = true;
            this.iconList = [];
            this.$edApi
                .getIconfontData(this.pageInfo)
                .then((res) => {
                    if (res.data.code == 200) {
                        let data = res.data.data.icons;
                        this.sensors.track("searchSymbolResult", {
                            Catalogues: "editFileProcess",
                            search_words: this.searchStr,
                            search_class: "icon",
                            is_find_symbol: data.length > 0 ? "findSomething" : "noResult",
                        });
                        this.iconList = data;
                        if (data.length == 0) {
                            this.end = true;
                        }
                        this.$nextTick(() => {
                            this.registObserve();
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        nextPage() {
            if (this.loading) return;
            this.loading = true;
            this.pageInfo.page = this.pageInfo.page + 1;
            this.$edApi
                .getIconfontData(this.pageInfo)
                .then((res) => {
                    if (res.data.code == 200) {
                        let data = res.data.data.icons;
                        this.iconList = this.iconList.concat(data);
                        if (data.length == 0) {
                            this.end = true;
                        }
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        observe = null;
        registObserve() {
            this.cancelObserve();
            this.addObserve();
        }
        cancelObserve() {
            if (this.observe) {
                this.observe.unobserve(this.$refs.scrollEl);
                this.observe = null;
            }
        }
        addObserve() {
            if (this.observe) return;
            let dom = this.$refs.scrollEl;
            console.log(this.loading, this.end);
            if (dom) {
                this.observe = new (window as any).IntersectionObserver((e: any) => {
                    console.log(e[0], ">>>e");
                    if (e[0] && e[0].isIntersecting && !this.loading) {
                        this.nextPage();
                    }
                });
                this.observe.observe(dom);
            }
        }

        reset() {
            this.pluginColor = "";
            this.pxIndex = 3;
            this.colorModeIndex = 0;
            this.searchStr = "";
            this.end = false;
            this.pageInfo = {
                // 默认参数
                fills: "",
                page: 1,
                pageSize: 80,
                q: "iconfont",
            };
            this.getData();
            this.showColor = false;
        }

        imgDom = null;
        svgData = {
            svg: "",
            w: 0,
            h: 0,
            color: "",
        };
        createPreview() {
            this.imgDom = document.createElement("img");
            this.imgDom.src = `data:image/svg+xml;utf8,${encodeURIComponent(decodeURIComponent(this.svgData.svg))}`;
            this.imgDom.id = "previewIMG";
            this.imgDom.style.cssText = `
                display: none;
                position:absolute;
                left: -999px;
                top: -999px;
                width: 32px;
                height: 32px;
                object-fit:contain;
                pointer-events:none;
                z-index: 1000;
            `;
            document.body.appendChild(this.imgDom);
        }
        movePreview(x: number, y: number) {
            if (this.imgDom) {
                this.imgDom.style.left = `${x}px`;
                this.imgDom.style.top = `${y}px`;
            }
        }
        hiddenPreview() {
            this.imgDom && (this.imgDom.style.display = "none");
        }
        showPreview() {
            this.imgDom && (this.imgDom.style.display = "block");
        }
        removePreview() {
            if (this.imgDom) {
                document.body.removeChild(this.imgDom);
                this.imgDom = null;
            }
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop;
        }
        doMousedown(svg: string) {
            const px = this.dataList[this.pxIndex].value;
            let isMove = false;
            this.svgData = {
                svg: svg,
                w: px,
                h: px,
                color: this.pluginColor,
            };
            this.createPreview();
            let timer = setTimeout(() => {
                isMove = true;
            }, 150);

            document.onmousemove = (ev: MouseEvent) => {
                if (!isMove) return;
                this.showPreview();
                const imgWidth = 32,
                    imgHeight = 32;
                this.movePreview(ev.pageX - imgWidth / 2, ev.pageY - imgHeight / 2);
            };
            document.onmouseup = (ev: MouseEvent) => {
                clearTimeout(timer);
                const left = ev.pageX - this.sceneLeft,
                    top = ev.pageY - this.sceneTop;
                const setPostion = true;
                const setSize = true;
                document.onmousemove = null;
                document.onmouseup = null;
                this.sensors.track("useSymbolLibrary", {
                    Catalogues: "editFileProcess",
                    symbol_library_class: "icon",
                });
                this.removePreview();
                if (isMove) {
                    window["_view"].insertSVGFromStr(
                        this.svgData.svg,
                        setSize,
                        this.svgData.w,
                        this.svgData.h,
                        this.svgData.color,
                        setPostion,
                        left,
                        top
                    );
                } else {
                    window["_view"].insertSVGFromStr(this.svgData.svg, setSize, this.svgData.w, this.svgData.h, this.svgData.color);
                }
            };
        }
        created() {}
        mounted() {
            this.getData();
        }
        beforeDestroy() {
            this.cancelObserve();
        }
    }
</script>
<i18n>
{
    "zh": {
        "nodata": "暂无相关内容",
        "allColor": "全部",
        "singleColor": "单色",
        "manyColor": "多色",
        "placeholder": "搜索图表",
        "tips": "素材内容版权归作者及来源网站所有，未经iconfont或其关联公司书面授权许可，不得用于任何商业用途。若希望使用该素材，请提前联系作者，取得授权后再进行使用，避免造成侵犯作者知识产权。"

    },
    "en": {
        "nodata": "No related content available",
        "allColor": "All",
        "singleColor": "Monocolor",
        "manyColor": "Multicolor",
        "placeholder": "Search Charts",
        "tips": "The copyright of the materials belongs to the authors and the source websites. They may not be used for any commercial purpose without the written authorization of iconfont or its affiliates.If you want to use this material, please contact the author in advance to obtain authorization before use to avoid infringing upon the author's intellectual property rights."
    },
    "fr": {
        "nodata": "Aucun contenu associé disponible",
        "allColor": "Toutes",
        "singleColor": "Monochrome",
        "manyColor": "Multicolore",
        "tips": "Les droits d'auteur des documents appartiennent aux auteurs et aux sites Web sources. Ils ne peuvent pas être utilisés à des fins commerciales sans l'autorisation écrite d'iconfont ou de ses filiales.Si vous souhaitez utiliser ce document, contactez l'auteur au préalable pour obtenir une autorisation avant utilisation afin d'éviter toute violation de ses droits de propriété intellectuelle."
    },
    "de": {
        "nodata": "Keine zugehörigen Inhalte verfügbar",
        "allColor": "Alle",
        "singleColor": "Einfarbig",
        "manyColor": "Mehrfarbig",
        "tips": "Das Copyright für die Materialien liegt bei den Autoren und den Quellseiten. Sie dürfen ohne die schriftliche Genehmigung von iconfont oder seinen verbundenen Unternehmen nicht für kommerzielle Zwecke verwendet werden.Wenn Sie dieses Material verwenden möchten, kontaktieren Sie bitte den Autor im Voraus, um vor der Verwendung eine Genehmigung einzuholen und so eine Verletzung der geistigen Eigentumsrechte des Autors zu vermeiden."
    },
    "jp": {
        "nodata": "関連コンテンツはありません",
        "allColor": "すべて",
        "singleColor": "モノカラー",
        "manyColor": "マルチカラー",
        "tips": "素材の著作権は、作成者およびソース Web サイトに帰属します。これらの素材は、iconfont またはそのアフィリエイトの書面による許可がない限り、いかなる商業目的にも使用することはできません。この素材を使用する場合は、作成者の知的財産権を侵害しないように、使用前に事前に作成者に連絡して許可を得てください。"
    },
    "es": {
        "nodata": "No hay contenido relacionado disponible",
        "allColor": "Todos",
        "singleColor": "Monocolor",
        "manyColor": "Multicolor",
        "tips": "Los derechos de autor de los materiales pertenecen a los autores y a los sitios web de origen. No podrán utilizarse con fines comerciales sin la autorización por escrito de iconfont o de sus filiales.Si desea utilizar este material, póngase en contacto con el autor con antelación para obtener autorización antes de utilizarlo y evitar así infringir sus derechos de propiedad intelectual."
    },
    "pt": {
        "nodata": "Nenhum conteúdo relacionado disponível",
        "allColor": "Tudo",
        "singleColor": "Monocromático",
        "manyColor": "Multicolorido",
        "tips": "Os direitos autorais dos materiais pertencem aos autores e aos sites de origem. Eles não podem ser usados para qualquer finalidade comercial sem a autorização por escrito da iconfont ou de suas afiliadas.Se você quiser usar este material, entre em contato com o autor com antecedência para obter autorização antes do uso para evitar violação dos direitos de propriedade intelectual do autor."
    },
    "it": {
        "nodata": "Nessun contenuto correlato disponibile",
        "allColor": "Tutti",
        "singleColor": "Monocolore",
        "manyColor": "Multicolore",
        "tips": "Il copyright del materiale appartiene agli autori e ai siti web di origine. Non possono essere utilizzati per scopi commerciali senza l'autorizzazione scritta di iconfont o delle sue affiliate.Se si desidera utilizzare questo materiale, contattare l'autore in anticipo per ottenere l'autorizzazione prima dell'uso al fine di evitare di violare i diritti di proprietà intellettuale dell'autore."
    },
    "tw": {
        "nodata": "沒有可用的相關內容",
        "allColor": "全部",
        "singleColor": "單色",
        "manyColor": "多色",
        "tips": "資料版權歸作者及來源網站所有。未經 iconfont 或其關係企業書面授權，不得用於任何商業用途。如果您想使用此資料，請在使用前聯絡作者以取得授權，以免侵犯作者的智慧財產權。"
    },
    "kr": {
        "nodata": "사용 가능한 관련 콘텐츠 없음",
        "allColor": "모두",
        "singleColor": "단색",
        "manyColor": "다색",
        "tips": "자료의 저작권은 저작자와 소스 웹 사이트에 있습니다. iconfont 또는 그 계열사의 서면 승인 없이는 상업적 목적으로 사용할 수 없습니다.이 자료를 사용하려면 저작자의 지적재산권을 침해하지 않도록 사전에 저작자에게 연락하여 승인을 받으시기 바랍니다."
    }
}
</i18n>
